import { IsArray, IsString } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO pour définir/retirer les délégués d'une classe
 */
export class UpdateClassDelegatesDto {
  @ApiProperty({
    description: 'IDs des utilisateurs à définir comme délégués',
    type: [String],
    example: ['user-1', 'user-2'],
  })
  @IsArray()
  @IsString({ each: true })
  delegateUserIds!: string[]
}
